export default "__VITE_ASSET__cEq$uCYo__"